module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-square-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-788a4bbe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/FulfillingSquareSpinner.vue
// module id = 390
// module chunks = 1